import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import { RenderModalStack } from 'contexts/modal/useModalStack';

import NavBar from './navbar/NavBar';
import DevMenu from './DevMenu';
import { Toaster } from 'react-hot-toast';
import RoutePlanFeedbackPrompter from 'pages/TransportLogistics/Ruttfeedback/RoutePlanFeedbackPrompter';

const AppLayout: FC = () => {
  return (
    <>
      <NavBar />

      <Outlet />
      <RenderModalStack />
      <Toaster position="bottom-right" />
      <RoutePlanFeedbackPrompter />
      <DevMenu />
    </>
  );
};

export default AppLayout;
